<template>

    <div class="lottie-player">

        <div class="loading" v-if="!loaded">Loading...</div>

    </div>

</template>


<script>

    export default {

        name: 'lottie-player',

        data() {

            return {

                player: false,
                loaded: false,

            }

        },

        props: {

			path: String,
			name: String,

        },

        watch: {

            path() {

                console.log('LC: path changed', this.name);

                if(this.player) {

                    this.player.destroy();

                }

                this.load();


            }

        },

        mounted() {

            console.log('LC: mounted', this.name);
            this.load();

        },

        methods: {

            load() {

                this.loaded = false;

                console.log('LC: loading', this.name);

                if(typeof(window.lottie) !== 'undefined') {

                    this.player = window.lottie.loadAnimation({
                        container:  this.$el,
                        renderer: 'svg',
                        loop: false,
                        autoplay: false,
                        path: this.path,
                        name: this.name,
                    });

                    this.player.addEventListener('DOMLoaded', () => {

                        this.loaded = true;

                    });

                    this.player.play();

                 }

            }

        }

    }

</script>